module.exports = __webpack_public_path__ + "static/media/boatlogo.6f991f61.svg";